export default "__VITE_ASSET__DjedgNEF__"